import axios from "axios";
import authHeader from '@/services/auth/AuthHeader';

/** Table booking (bordbestilling): the restaurant's side. Every call carries the logged-in merchant. */
class BookingService {
    merchant(){
        return JSON.parse(localStorage.getItem('user')).merchant;
    }

    getSettings(locationId){
        let url = '/api/booking/getSettings?merchant=' + this.merchant() + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    saveSettings(locationId, settings){
        return axios.post('/api/booking/saveSettings', { merchant: this.merchant(), locationId, settings },
            { headers: authHeader() });
    }

    /** Bookings on [fromDate, toDate] (yyyy-MM-dd), every status, earliest first. */
    list(locationId, fromDate, toDate){
        let url = '/api/booking/list?merchant=' + this.merchant() + '&locationId=' + locationId
            + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    /** A booking entered by staff. `force` skips the seat check. */
    create(locationId, booking, force){
        return axios.post('/api/booking/create', { merchant: this.merchant(), locationId, force: !!force, ...booking },
            { headers: authHeader() });
    }

    confirm(bookingId){
        return axios.post('/api/booking/confirm', { merchant: this.merchant(), bookingId }, { headers: authHeader() });
    }

    cancel(bookingId, notifyGuest){
        return axios.post('/api/booking/cancel', { merchant: this.merchant(), bookingId, notifyGuest },
            { headers: authHeader() });
    }
}

export default new BookingService();
